import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "orders";
// initial state
const state = () => ({
  all: [],
  orders: [],
  items: [],
  orderSupplierItems: [],
  order: {},
  supplier_orders: [],
  supplierOrder: {},
});

// getters
const getters = {
  getAll: (state) => state.all,
  getOrderSuppliers: (state) => state.supplier_orders,
  getItems: (state) => state.items,

  getOrderSupplierItems: (state) => state.orderSupplierItems,
  getOrder: (state) => state.order,
  getSupplierOrder: (state) => state.supplierOrder,

  getOrders: (state) => {
    return state.orders;
  },

  getSupplierOrders: (state) => {
    return state.supplier_orders;
  },
  totalPriceTTCItems: (state) => {
    return state.orderSupplierItems.reduce(
      (acc, val) => acc + val.quantity * val.priceTTC,
      0
    );
  },

  totalQuantityItems: (state) => {
    return state.orderSupplierItems.reduce((acc, val) => acc + val.quantity, 0);
  },
  numberItems: (state) => {
    return state.orderSupplierItems.length;
  },

  // order supplier
  getTotalPriceTTCOrderSupplierItems: (state) => {
    return state.orderSupplierItems.reduce(
      (acc, val) => acc + val.totalPriceTTC,
      0
    );
  },

  getTotalQuantityOrderSupplierItems: (state) => {
    return state.orderSupplierItems.reduce((acc, val) => acc + val.quantity, 0);
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await commit("SET_ORDERS", []);
    await axios.get(api).then((response) => {
      let orders = response.data;
      commit("SET_ORDERS", orders);
    });
  },

  async getSupplierOrders({ commit }) {
    await axios.get(api + "_quantities_suppliers").then((response) => {
      let orders = response.data;
      commit("setSupplierOrders", orders);
    });
  },

  async fetchSupplierOrders({ commit }) {
    await axios.get(api + "_suppliers").then((response) => {
      let orders = response.data;
      commit("setSupplierOrders", orders);
    });
  },

  async getAllItems({ commit }) {
    await axios.get(api + "_items").then((response) => {
      commit("setItems", response.data);
    });
  },
  async show({ commit }, reference) {
    await commit("SET_ORDER", {});
    await this.$api.show(`${api}/${reference}`).then((response) => {
      let order = response.data;
      commit("SET_ORDER", order);
    });
    // await axios.get(api + "/" + reference).then((response) => {
    //   let order = response.data;
    //   commit("SET_ORDER", order);
    // });
  },

  async showSupplierOrder({ commit }, reference) {
    await axios.get(api + "_suppliers/" + reference).then((response) => {
      let order = response.data;
      commit("SET_SUPPLIER_ORDER", order);
    });
  },

  async printSupplierOrder({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .get(api + "_suppliers_print_order/" + reference, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Commande.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async storeItem({ commit, dispatch }, data) {
    await this.$api.create(api + "_items", data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      if (status == "success") {
        commit("setItems", response.data.data);
      }
    });
  },

  async updateItem({ commit, dispatch }, data) {
    await this.$api.update(api + "_items/" + data.id, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        let order = response.data.data;
        console.log(order);
        commit("SET_ORDER", order);
      }
    });
  },

  async destroyItem({ commit, dispatch }, id) {
    await this.$api.delete(api + "_items/" + id).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        let order = response.data.data;
        commit("setItems", order);
      }
    });
  },

  async saveDelivery({ commit }, data) {
    await this.$api
      .create(`${api}_delivery/${data.reference}`, data)
      .then((response) => {
        let status = response.data.status;
        let order = response.data.data;

        if (status == "success") {
          router.push({
            name: "orders-details",
            params: {
              reference: order.reference,
            },
          });
        }
      });
  },

  async addToSale({ commit }, reference) {
    await this.$api
      .create(`${api}_to_sale/${reference}`, {})
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({
            name: "orders-index",
          });
        }
      });
  },

  async validated({ commit }, reference) {
    await this.$api
      .create(`${api}_validated/${reference}`, {})
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({
            name: "orders-index",
          });
        }
      });
  },

  async cancelValidated({ commit }, reference) {
    await this.$api
      .create(`${api}_cancel_validated/${reference}`, {})
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({
            name: "orders-index",
          });
        }
      });
  },

  async cancelDelivery({ commit }, reference) {
    const response = await this.$api.create(
      `${api}_delivery_cancel/${reference}`,
      []
    );

    let status = response.data.status;

    if (status === "success") {
      router.push({
        name: "orders-index",
      });
    }
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "orders-index" });
      }
    });
  },

  async storeSupplierOrder({ commit, dispatch }, data) {
    await axios.post(api + "_suppliers", data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({ name: "orders-suppliers-index" });
      }
    });
  },

  async updateSupplierOrder({ commit, dispatch }, data) {
    await axios
      .put(api + "_suppliers/" + data.reference, data)
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;
        dispatch("notification/store", { status, message }, { root: true });
        if (status == "success") {
          router.push({ name: "orders-suppliers-index" });
        }
      });
  },

  async sendByEmailSupplierOrder({ dispatch }, reference) {
    dispatch(
      "notification/storeDownloading",
      { status: "success", message: "downloading..." },
      { root: true }
    );
    await axios
      .get(api + "_suppliers_send_by_email/" + reference)
      .then((response) => {
        let status = response.data.status;
        let message = response.data.message;

        dispatch("notification/store", { status, message }, { root: true });
      });
  },

  async update({ commit }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let status = response.data.status;

        if (status == "success") {
          router.push({ name: "orders-index" });
        }
      });
  },

  async destroy({ commit }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "orders-index" });
      }
    });
  },

  async getOrderSupplierItem({ commit, dispatch }) {
    await axios.get(api + "_suppliers_items").then((response) => {
      commit("SET_ORDER_SUPPLIER_ITEMS", response.data);
    });
  },

  async storeOrderSupplierItem({ commit, dispatch }, data) {
    await axios.post(api + "_suppliers_items", data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("SET_ORDER_SUPPLIER_ITEMS", response.data.data);
      }
    });
  },
  async destroyOrderSupplierItem({ commit, dispatch }, id) {
    await axios.delete(api + "_suppliers_items/" + id).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("SET_ORDER_SUPPLIER_ITEMS", response.data.data);
      }
    });
  },

  async printBillPage({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .post(api + "_print_bill_page/" + reference, [], {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "BON-DE-LIVRAISON.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printPurchaseOrderPage({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .get(api + "_print_purchase_order_page/" + reference, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "BON-DE-COMMANDE.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printDeliveryReceipt({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .post(api + "_delivery_receipt/" + reference, [], {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "BON-DE-COMMANDE.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async printManyPurchaseOrderPage({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        { status: "success", message: "downloading..." },
        { root: true }
      );
      const response = await axios
        .post(
          api + "_print_many_purchase_order_page",
          { selections: data },
          {
            responseType: "blob", // Set the response type to 'blob' to handle binary data
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Facture.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async filter({ dispatch, commit }, data) {
    await this.$api
      .create(api + "_filter", data, { confirm: false })
      .then((response) => {
        commit("SET_ORDERS", response.data);
      });
  },
};

// mutations
const mutations = {
  SET_ORDERS(state, orders) {
    state.all = orders;
    state.orders = orders;
  },
  setSupplierOrders(state, orders) {
    state.supplier_orders = orders;
  },

  setItems(state, items) {
    state.items = items;
  },
  SET_ORDER_SUPPLIER_ITEMS(state, items) {
    state.orderSupplierItems = items;
  },
  SET_ORDER(state, order) {
    state.order = order;
  },
  SET_SUPPLIER_ORDER(state, supplier_order) {
    state.supplierOrder = supplier_order;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
